// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CodelistCondition
 */
export interface CodelistCondition {
    /**
     * 
     * @type {string}
     * @memberof CodelistCondition
     */
    column: string;
    /**
     * 
     * @type {string}
     * @memberof CodelistCondition
     */
    value: string;
}

/**
 * Check if a given object implements the CodelistCondition interface.
 */
export function instanceOfCodelistCondition(value: object): value is CodelistCondition {
    if (!('column' in value) || value['column'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function CodelistConditionFromJSON(json: any): CodelistCondition {
    return CodelistConditionFromJSONTyped(json, false);
}

export function CodelistConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CodelistCondition {
    if (json == null) {
        return json;
    }
    return {
        
        'column': json['column'],
        'value': json['value'],
    };
}

export function CodelistConditionToJSON(json: any): CodelistCondition {
    return CodelistConditionToJSONTyped(json, false);
}

export function CodelistConditionToJSONTyped(value?: CodelistCondition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'column': value['column'],
        'value': value['value'],
    };
}
